import { Link } from "react-router-dom";
//@ts-ignore
import { tw } from "@careinfo/tailwind";

const LinkCard = (props: any) => {
  return (
    <Link
      to={props?.href}
      className={tw`block  mb-8 focus-visible:bg-primary-light focus-visible:scale-[1.02] focus-visible:outline-none hover:bg-primary-light transition-all duration-500 hover:scale-[1.02] min-h-fit`}
    >
      <span
        className={tw`w-full  flex justify-center gap-x-6 uppercase items-center h-[50px] border-[1px] border-primary text-primary `}
      >
        {props?.icon}
        {props?.label}
      </span>
    </Link>
  );
};

export default LinkCard;
